import { render, staticRenderFns } from "./UnderMaintenance.vue?vue&type=template&id=a91ac116&scoped=true"
var script = {}
import style0 from "./UnderMaintenance.vue?vue&type=style&index=0&id=a91ac116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91ac116",
  null
  
)

export default component.exports